const base = require('./data/base')
const staging = require('./data/staging')
const production = require('./data/production')
const merge = require('lodash/merge')

/* eslint-disable no-console */
// console.log(`当前环境: ${process.env.NODE_ENV}`)
/* eslint-enable no-console */

module.exports = function (appName) {
  
  let c
  switch (process.env.NODE_ENV) {
    case 'production':
      c = production;
      break
    case 'beta':
      c = beta;
      break
    case 'staging':
      c = staging;
      break
    default: {
      let development
      try {
        development = require('./data/development')
      } catch ( e ) {
        development = {}
      }
      c = development
    }
  }
  
  const config = merge({}, base, c)
  
  let mergeConf
  if (appName === undefined) {
    mergeConf = config.app
  } else {
    mergeConf = config.activity && config.activity[ appName ]
  }
  mergeConf = mergeConf || {}
  
  delete config.app
  delete config.activity
  
  return merge(config, mergeConf)
}